/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 2v2H3.962v16H20v-9h2v11H2V2zm4.781-.374 4.332 4.414L11.22 17.42H6.888v-4.414zm0 2.828L8.85 13.835v1.586h1.556l8.931-9.381z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEditBox as EditBox };
